import { GetEditInfo, SenderInfoDb, util } from "..";
import * as sonbpIfconst from "../sonbpIf/base/constants";
import { constDialogMessage, dialogUtil } from "../util";
import { Logger } from "../util/logger";
import { BaseLogicClass } from "./edit.baseLogic";
import { EditConst, EDIT_MODE_KIND, kumihanHv, KUMIHAN_HV } from "./edit.const";
import { kumihanContoroller, kumihanGreetingRequestParam, kumihanRequestParam, kumihanResponseParam, kumihanSenderRequestParam, senderTranEntityEx } from "./edit.entity";
import { itemVenderProperty, sonbpIFContoroller } from "./edit.sonbp_if";
import { editUtil } from "./edit.tool";
import { SearchZipToAddress } from "../entity/SearchZipToAddressEntitys"
import* as es6promise from "es6-promise";

/**
 * 差出人関連の処理クラス
 * 
 * TODO ★名前に "Sender"が付く関数は全てこちらへ移しています。
 * 
 */
export class SenderLogicClass extends BaseLogicClass {

// #region ■定数・変数

    /**
     * 組版トークン 
     */
    private get kumihanToken(): string {

        return this.editInfo.kumihanToken;
    }

    /**
     * WebAPI[Edit/GetEditInfo]のレスポンスのdata部
     */
    private get editInfo(): GetEditInfo.GetEditInfoResponseEntity {
        return this._edctrl.editInfo;
    }

    /**
     * 住所検索(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_SEARCHADDRESS: string = "Edit/SearchZipToAddress";
       

// #endregion

    /**
    * 住所検索のエラーダイアログ表示関数
    */
    private showAddrSearchErroDlg(errorMsg: string) {
        util.dialogUtil.createErrorDialog(errorMsg, () => {
            (<HTMLInputElement>this._vue.$refs.zipCode1).focus();
            util.dialogUtil.closeErrorDialog();
            return;
        });
    }    

// #region ■イベント

    /**
     * ツールメニュー：差出人情報編集押下メソッド
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * */
    public btnClickSenderMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {

        Logger.debug("ツールメニュー：差出人情報編集押下メソッド");

        if (this._edctrl.editMode === EDIT_MODE_KIND.SENDER) {
            return;
        }

        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(EDIT_MODE_KIND.SENDER,
            () => {
                // 正常終了の場合
                this._edctrl.editMode = EDIT_MODE_KIND.SENDER;

                if (this._usePcDesign) {
                    // PC用
                    // パネルの表示制御
                    this._vue.$data.Show.BalloonGuidance = false;
                    this._vue.$data.Show.PhotoList = false;
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.GreetingPanel = false;
                    this._vue.$data.Show.SenderPanel = true;
                    this._vue.$data.Show.StampPanel = false;
                    this._vue.$data.Show.MyStampPanel = false;
                    this._vue.$data.Show.TegakiStampPanel = false;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveSetPhotoMenu = false;
                    this._vue.$data.ActiveManiPhotoMenu = false;
                    this._vue.$data.ActiveGreetingMenu = false;
                    this._vue.$data.ActiveSenderMenu = true;
                    this._vue.$data.ActiveStampMenu = false;
                    this._vue.$data.ActiveMyStampMenu = false;
                    this._vue.$data.ActiveTegakiStampMenu = false;
                    this._vue.$data.ActiveFinishSelectMenu = false;

                    // フェードインアウトの初期化
                    this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
                    this._vue.$data.SenderInfo.fade.In = false;
                    this._vue.$data.SenderInfo.fade.Out = false;

                    // オブジェクト操作パレットの表示制御
                    this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.SENDER, null);


                    this.sonbpIfController.getSenderTextList((list: itemVenderProperty[]) => {
                        // 作成済みの差出人情報が存在するか判定
                        if (0 < list.length) {

                            if (selectedItemVp === null) {

                                // 先頭アイテム選択
                                this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_SENDER_TXT,
                                    () => {
                                        Logger.debug("選択アイテムの指定 成功");
                                        this._vue.$data.Show.OparatePalletCover4Top = false;
                                        this._vue.$data.SenderInfo.DelBtnEnable = true;
                                        if (this.editInfo.info.sender.senderInfo.addresses.length == 0) {
                                            // DBとPDFが一致しない時はパレット初期化
                                            this.InitSenderPallet();
                                        }
                                    },
                                    () => {
                                        this.InitSenderPallet();
                                    },
                                    () => {
                                        Logger.error("選択アイテムの指定 失敗");
                                        this.InitSenderPallet();
                                    }
                                );
                            } else {

                                // アイテム選択
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_SENDER_TXT, selectedItemVp.idx,
                                    () => {
                                        Logger.debug("選択アイテムの指定 成功");
                                        this._vue.$data.Show.OparatePalletCover4Top = false;
                                        this._vue.$data.SenderInfo.DelBtnEnable = true;
                                        if (this.editInfo.info.sender.senderInfo.addresses.length == 0) {
                                            // DBとPDFが一致しない時はパレット初期化
                                            this.InitSenderPallet();
                                        }
                                    },
                                    () => {
                                        Logger.error("選択アイテムの指定 失敗");
                                        this.InitSenderPallet();
                                    }
                                );
                            }
                        }
                        else {
                            // 存在しない場合、差出人の編集表示
                            this.InitSenderPallet();
                        }
                    });
                }
                else {
                    // SP用
                    // 履歴処理開始
                    this.sonbpIfController.historyStart();

                    // ヘッダーメニュー
                    this._vue.$data.Show.ReturnFlowBtn = false;
                    this._vue.$data.Show.ReturnHomeBtn = false;
                    this._vue.$data.Show.NextFlowBtn = false;
                    this._vue.$data.Show.NextHomeFromImgListBtn = false;
                    this._vue.$data.Show.NextHomeFromMyStampListBtn = false;
                    this._vue.$data.Show.NextHomeFromTegakiStampListBtn = false;

                    // メインメニュー
                    this._vue.$data.Show.SetPhotoMenu = false;
                    // あいさつ文エリア
                    this._vue.$data.Show.GreetingPanel = false;
                    // スタンプエリア
                    this._vue.$data.Show.StampPanel = false;
                    this._vue.$data.Show.MyStampPanel = false;
                    this._vue.$data.Show.TegakiStampPanel = false;
                    this._vue.$data.Show.TegakiColorPanel = false;

                    // 差出人エリア
                    this._vue.$data.Show.SenderPanel = false;

                    this.sonbpIfController.getSenderTextList((list: itemVenderProperty[]) => {
                        // 作成済みの差出人情報が存在するか判定
                        if (0 < list.length) {
                            // 存在する場合、差出人の位置調整表示
                            this._vue.$data.Header.Title = EditConst.TITLE_SENDER;

                            this._vue.$data.Show.ReturnSenderHomeBtn = false;
                            this._vue.$data.Show.ReturnHomeExBtn = true;
                            this._vue.$data.Show.SenderDeleteBtn = true;
                            this._vue.$data.Show.CommitNextHomeBtn = true;

                            // オブジェクト操作パレットの表示制御
                            this._vue.$data.Show.OparatePallet = true;
                            this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.SENDER, null);

                            // タッチイベント制御(無効)
                            this._edctrl.touchEventChange(false);

                            if (selectedItemVp === null) {

                                // 先頭アイテムを選択
                                this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_SENDER_TXT,
                                    (selectItem: itemVenderProperty) => { Logger.debug("選択アイテムの指定 成功"); },
                                    () => { },
                                    () => { Logger.error("選択アイテムの指定 失敗"); }
                                );
                            } else {

                                // アイテム選択
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_SENDER_TXT, selectedItemVp.idx,
                                    () => { Logger.debug("選択アイテムの指定 成功"); },
                                    () => { Logger.error("選択アイテムの指定 失敗"); }
                                );
                            }
                        }
                        else {
                            // 存在しない場合、差出人の編集表示
                            this.setSenderEditMode();
                        }
                    });
                }
            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });

        // 外字入力ボタンの初期表示
        this.ShowGaijiButton(false);
    }

    /**
     * 差出人パネル フォント変更
     * @param event
     */
    public onChangeSenderFont(event: JQueryEventObject): void {

        // フォントサンプル更新
        const selFont = this.editInfo.master.font.find(x => x.name == this._vue.$data.SenderInfo.Setting.Font);

        if (selFont !== undefined) {
            this._vue.$data.SenderInfo.Setting.FontSample = selFont.url;
        }

        // 外字入力ボタンの初期表示
        this.ShowGaijiButton(true);
    }

    /**
     * 差出人パネル 文字レイアウト変更
     * @param event
     */
    public onChangeSenderCharLayout(event: JQueryEventObject): void {
        // 行揃えコンボの切り替え(縦 or 横)
        if (this._vue.$data.SenderInfo.Setting.CharLayout == EditConst.CHAR_LAYOUT_Y) {
            this._vue.$data.SenderInfo.ShowSenderAlignY = true;
        }
        else {
            this._vue.$data.SenderInfo.ShowSenderAlignY = false;
        }
    }

    /**
     * 差出人パネル 入力内容を適用するボタン押下
     *
     * @param requesNew
     * @param event
     */
    public btnClickSenderSet(event: JQueryEventObject): void {

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // 選択差出人の存在チェック
        var selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
        Logger.debug("選択差出人 [" + JSON.stringify(selectItem) + "]");

        // 入力値取得
        let setOrder: senderTranEntityEx = this.getSenderOrder();
        let msgList: string[] = [];

        // 入力チェック
        Logger.debug("入力チェック", setOrder);
        if (!this.validSenderOrder(setOrder, msgList)) {
            // 入力チェックエラー
            util.dialogUtil.createErrorDialog(
                util.constDialogMessage.WARN_EDIT_BASE + msgList.join("<br>"),
                () => {
                    // ローディングダイアログ終了
                    util.dialogUtil.closeLoading();
                    dialogUtil.closeErrorDialog();
                    if (this._vue.$data.FocusGaijiShortCut) {
                        (<HTMLInputElement>this._vue.$refs[this._vue.$data.FocusGaijiShortCut]).focus();
                    }
                });
            return;
        }

        // 組方向
        const hv: kumihanHv = (setOrder.charLayout === EditConst.CHAR_LAYOUT_T) ? KUMIHAN_HV.VERTICAL : KUMIHAN_HV.HORIZONTAL;

        // 幅・高さ
        let masterSize: { w: number, h: number };
        if (0 < this.editInfo.master.design.sender.width && 0 < this.editInfo.master.design.sender.height) {
            const masterHv: kumihanHv = editUtil.directionToHv(this.editInfo.master.design.sender.direction);
            if (hv === masterHv) {
                masterSize = {
                    w: this.editInfo.master.design.sender.width,
                    h: this.editInfo.master.design.sender.height
                };
            }
            else {
                masterSize = {
                    w: this.editInfo.master.design.sender.height,
                    h: this.editInfo.master.design.sender.width
                };
            }
        }

        const kumihan: kumihanContoroller = new kumihanContoroller(this.editInfo.kumihanURL);

        // 通常入力／自由入力 判定
        if (this._vue.$data.SenderInfo.IsNormalInput) {
            // 通常入力の場合

            // 組版パラメータ生成
            let kumihanParam: kumihanSenderRequestParam = new kumihanSenderRequestParam();

            // 組版トークン
            kumihanParam.session = this.kumihanToken;

            // レイアウト記号
            kumihanParam.layout_cd = this.getLayoutCd(setOrder.sender.senderInfo.isHojin, setOrder.charLayout)
            setOrder.sender.layout = kumihanParam.layout_cd;

            // 組方向
            kumihanParam.hv = hv;

            // 幅
            kumihanParam.width = masterSize.w;
            // 高さ
            kumihanParam.height = masterSize.h;

            // フォント
            kumihanParam.ftype = setOrder.fontMaster.id;
            // 文字色
            kumihanParam.color1 = setOrder.fontColorMaster.rgb;
            if (setOrder.outlineChar) {
                // フチ文字色
                kumihanParam.color2 = setOrder.outlineFontColorMaster.rgb;
            }

            if (0 < setOrder.sender.senderInfo.addresses.length) {
                // 郵便番号１
                kumihanParam.adr1_post1 = setOrder.sender.senderInfo.addresses[0].yubin1;
                // 郵便番号２
                kumihanParam.adr1_post2 = setOrder.sender.senderInfo.addresses[0].yubin2;

                // 住所１
                kumihanParam.adr1_adr1 = setOrder.sender.senderInfo.addresses[0].jusho1;
                // 住所２
                kumihanParam.adr1_adr2 = setOrder.sender.senderInfo.addresses[0].jusho2;
                // 住所３
                kumihanParam.adr1_adr3 = setOrder.sender.senderInfo.addresses[0].jusho3;

                // 電話番号タイプ１
                kumihanParam.adr1_teltype1 = this.telType2Gaiji(setOrder.sender.senderInfo.addresses[0].telType1);
                // 電話番号１
                kumihanParam.adr1_telno11 = setOrder.sender.senderInfo.addresses[0].telNo1_1;
                kumihanParam.adr1_telno12 = setOrder.sender.senderInfo.addresses[0].telNo1_2;
                kumihanParam.adr1_telno13 = setOrder.sender.senderInfo.addresses[0].telNo1_3;

                // 電話番号タイプ２
                kumihanParam.adr1_teltype2 = this.telType2Gaiji(setOrder.sender.senderInfo.addresses[0].telType2);
                // 電話番号２
                kumihanParam.adr1_telno21 = setOrder.sender.senderInfo.addresses[0].telNo2_1;
                kumihanParam.adr1_telno22 = setOrder.sender.senderInfo.addresses[0].telNo2_2;
                kumihanParam.adr1_telno23 = setOrder.sender.senderInfo.addresses[0].telNo2_3;
            }

            // E-mail
            if (0 < setOrder.sender.senderInfo.emails.length) {
                kumihanParam.eh1_adr = setOrder.sender.senderInfo.emails[0].address;
                if (1 < setOrder.sender.senderInfo.emails.length) {
                    kumihanParam.eh2_adr = setOrder.sender.senderInfo.emails[1].address;
                }
            }

            if (0 < setOrder.sender.senderInfo.names.length) {
                // 姓
                kumihanParam.name1_fname = setOrder.sender.senderInfo.names[0].firstName;
                // 名
                kumihanParam.name1_lname = setOrder.sender.senderInfo.names[0].lastName;
                // 添書き
                kumihanParam.name1_ps = setOrder.sender.senderInfo.names[0].ps;
                // 姓ルビ
                kumihanParam.name1_fruby = setOrder.sender.senderInfo.names[0].firstRubi;
                // 姓ルビ
                kumihanParam.name1_lruby = setOrder.sender.senderInfo.names[0].lastRubi;
            }

            if (setOrder.sender.senderInfo.isHojin && 0 < setOrder.sender.senderInfo.corps.length) {
                // 会社名
                kumihanParam.corp1_name = setOrder.sender.senderInfo.corps[0].name;
                // 部署名
                kumihanParam.corp1_busyo = setOrder.sender.senderInfo.corps[0].busyo;
                // 肩書
                kumihanParam.name1_title = setOrder.sender.senderInfo.names[0].title;
            }
            else {
                // 歯抜けに対応する
                let endFlg: boolean = false
                for (let i: number = setOrder.sender.senderInfo.names.length - 1; i > 0; i--) {
                    if (endFlg && setOrder.sender.senderInfo.names[i].firstName == "") setOrder.sender.senderInfo.names[i].firstName = "　";
                    if (!endFlg && setOrder.sender.senderInfo.names[i].firstName != "") endFlg = true;
                }

                for (let i: number = 1; i < setOrder.sender.senderInfo.names.length; i++) {
                    // 名
                    kumihanParam["name" + (i + 1) + "_fname"] = setOrder.sender.senderInfo.names[i].firstName;
                    // 添書き
                    kumihanParam["name" + (i + 1) + "_ps"] = setOrder.sender.senderInfo.names[i].ps;
                    // 名ルビ
                    kumihanParam["name" + (i + 1) + "_fruby"] = setOrder.sender.senderInfo.names[i].firstRubi;
                }
            }

            // 組版API呼び出し
            kumihan.doKumihanSender(kumihanParam).then((result: kumihanResponseParam) => {
                this._vue.$data.Show.GaijiShortCutBtn = false;
                this._vue.$data.FocusGaijiShortCut = '';
                // sonbpへ連携
                this.setSenderText(selectItem, setOrder, kumihanParam, result);
            }).catch(() => {
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
                if (this._vue.$data.FocusGaijiShortCut) {
                    (<HTMLInputElement>this._vue.$refs[this._vue.$data.FocusGaijiShortCut]).focus();
                }
            });
        }
        else {
            // 自由入力の場合

            // 組版パラメータ生成
            let kumihanParam: kumihanGreetingRequestParam = new kumihanGreetingRequestParam();
            // 組版トークン
            kumihanParam.session = this.kumihanToken;
            // 組方向
            kumihanParam.hv = hv;
            // 文字サイズ
            kumihanParam.msize = setOrder.sender.size;
            // 原点
            kumihanParam.pivot = editUtil.align2Pivot(kumihanParam.hv, setOrder.alignDispVal);
            setOrder.sender.align = kumihanParam.pivot + "";

            // 幅
            kumihanParam.width = masterSize.w;
            kumihanParam.widthKumi = masterSize.w;
            // 高さ
            kumihanParam.height = masterSize.h;
            kumihanParam.heightKumi = masterSize.h;

            // フォント
            kumihanParam.ftype = setOrder.fontMaster.id;

            // 文字色
            kumihanParam.color1 = setOrder.fontColorMaster.rgb;
            if (setOrder.outlineChar) {
                // フチ文字色
                kumihanParam.color2 = setOrder.outlineFontColorMaster.rgb;
            }
            // 文章
            kumihanParam.payload = setOrder.sender.senderInfo.free.split('\n');

            // 自由文の縦組みは単位変換しない。
            if (kumihanParam.hv == KUMIHAN_HV.VERTICAL) {
                kumihanParam.vertGreetConvType = EditConst.GREETING_VERT_NO_CONV;
            }

            // 組版API呼び出し
            kumihan.doKumihanGreeting(kumihanParam).then((result: kumihanResponseParam) => {
                this._vue.$data.Show.GaijiShortCutBtn = false;
                this._vue.$data.FocusGaijiShortCut = '';
                // sonbpへ連携
                this.setSenderText(selectItem, setOrder, kumihanParam, result);
            }).catch(() => {
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
                if (this._vue.$data.FocusGaijiShortCut) {
                    (<HTMLInputElement>this._vue.$refs[this._vue.$data.FocusGaijiShortCut]).focus();
                }
            });

        }
    }

    /**
     * 差出人パネル 作成文章の削除ボタン押下
     * @param event
     */
    public btnClickSenderDelete(event: JQueryEventObject): void {

        // 選択テキスト取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();

        // sonbpへ削除依頼
        this.sonbpIfController.removeText(
            () => {
                Logger.debug("差出人テキスト削除 成功 =>", selectItem);

                // 正常終了の場合
                this.sonbpIfController.SenderInfo = senderTranEntityEx.createDef(this.editInfo.master.design.sender, this.editInfo.master.font, this.editInfo.master.color);
                this._vue.$data.Show.OparatePalletCover4Top = true;
                this._vue.$data.SenderInfo.DelBtnEnable = false;

                if (!this._usePcDesign) {
                    // SP用
                    // 履歴処理開始(reset)
                    this.sonbpIfController.historyStart();
                    this._vue.$data.Show.ReturnHomeExBtn = false;
                }
            }, () => {
                // 上記以外の場合
                Logger.error("差出人テキスト削除 失敗 =>", selectItem);
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_DEL_SENDER, dialogUtil.closeErrorDialog);

            });
    }

    /**
     * 差出人文字サイズ変更ボタンイベント
     * @param isPlus
     * @param event
     */
    public btnClickSenderFontSize(isPlus: boolean, event: JQueryEventObject): void {

        const val = parseFloat(this._vue.$data.SenderInfo.Setting.FontSize);
        if (isNaN(val)) return;

        if (isPlus) {
            if (val < EditConst.FONT_SIZE_MAX) {
                this._vue.$data.SenderInfo.Setting.FontSize = val + EditConst.FONT_SIZE_STEP;
            }
        } else {
            if (EditConst.FONT_SIZE_MIN < val) {
                this._vue.$data.SenderInfo.Setting.FontSize = val - EditConst.FONT_SIZE_STEP;
            }
        }

        return;
    }

    /**
     * 差出人の位置調整画面に戻るボタン押下(SP)
     * @param event
     */
    public returnSenderHomeBtn(event: JQueryEventObject): void {

        Logger.debug("差出人の位置調整画面に戻るボタン押下");

        // 差出人の存在チェック
        this.sonbpIfController.getSenderTextList((list: itemVenderProperty[]) => {
            // 外字メニューを非表示にする。
            this._vue.$data.Show.SenderGaijiMenu = false;
            this._vue.$data.Show.GaijiShortCutBtn = false;
            this._vue.$data.FocusGaijiShortCut = '';

            if (list.length === 0) {
                // 差出人が０件の場合には、ホームに戻る
                this._edctrl.btnClickReturnHome(true, true, null);
            }
            else {
                // タッチイベント制御(無効)
                this._edctrl.touchEventChange(false);

                // 履歴処理開始(reset)
                this.sonbpIfController.historyStart();

                // タイトル
                this._vue.$data.Header.Title = EditConst.TITLE_SENDER;

                // ヘッダメニュー
                this._vue.$data.Show.ReturnSenderHomeBtn = false;
                this._vue.$data.Show.CommitNextHomeBtn = true;
                this._vue.$data.Show.SenderDeleteBtn = true;

                // 差出人パネル非表示
                this._vue.$data.Show.SenderPanel = false;
                // 編集エリア表示
                this._vue.$data.Show.EditArea = true;

                // フッターメニュー
                this._vue.$data.Show.FooterMenu = true;
                this._vue.$data.Show.SetPhotoMenu = false;
                this._vue.$data.Show.EditImageMenu = false;
                this._vue.$data.Show.OparatePallet = true;

                // 削除ボタンの活性制御
                this._vue.$data.SenderInfo.DelBtnEnable = (0 < list.length) ? true : false;

                // オブジェクト操作メニュー
                this._edctrl.setModeOparatePalletForSp(EDIT_MODE_KIND.SENDER, null);
            }
        });

    }


    // #region ■イベント（PCのみ処理）

    /**
     * 差出人パネル 通常入力／自由入力押下
     * @param isNormal
     * @param event
     */
    public btnClickSenderInputType(isNormal: boolean, event: JQueryEventObject): void {

        if (isNormal) {
            // 通常入力指定
            if (!this._vue.$data.SenderInfo.Setting.AlignT) {
                this._vue.$data.SenderInfo.Setting.AlignT = EditConst.ALIGN_T_TOP;
            }
            if (!this._vue.$data.SenderInfo.Setting.AlignY) {
                this._vue.$data.SenderInfo.Setting.AlignY = EditConst.ALIGN_Y_LEFT;
            }
        }
        else {
            // 自由入力指定
            if (this._vue.$data.SenderInfo.Setting.CharLayoutEx === EditConst.CHAR_LAYOUT_T) {
                // 通常入力が縦書きの場合
                this._vue.$data.SenderInfo.Setting.CharLayout = EditConst.CHAR_LAYOUT_T;
                this._vue.$data.SenderInfo.ShowSenderAlignY = false;
            }
            else {
                // 上記以外の場合(横 or センター横)
                this._vue.$data.SenderInfo.Setting.CharLayout = EditConst.CHAR_LAYOUT_Y;
                this._vue.$data.SenderInfo.ShowSenderAlignY = true;
            }

            this._vue.$data.SenderInfo.Setting.AlignT = EditConst.ALIGN_T_TOP;
            this._vue.$data.SenderInfo.Setting.AlignY = EditConst.ALIGN_Y_LEFT;
        }

        this._vue.$data.SenderInfo.IsNormalInput = isNormal;
    }

    /**
     * 差出人パネル 個人用／法人用押下
     * @param usePersonal
     * @param event
     */
    public btnClickSenderInputUse(usePersonal: boolean, event: JQueryEventObject): void {

        this._vue.$data.SenderInfo.NormalInput.PersonalUse = usePersonal;

    }

    // #endregion

    // #region ■イベント（SPのみ処理）

    /**
     * 操作パネル→差出人アイテム編集ボタン押下メソッド(SP用)
     * */
    public btnClickEditSenderItem(event: JQueryEventObject): void {

        // タッチイベント制御(有効)
        this._edctrl.touchEventChange(true);

        this.setSenderEditMode();
    }

    /**
      * 差出人パネル 入力タイプ選択変更(SP用)
      * @param event
      */
    public onChangeSenderFormat(event: JQueryEventObject): void {

        let isNormal: boolean;

        if (this._vue.$data.SenderInfo.Setting.Format === EditConst.SENDER_TYPE_FREE_STR) {
            // 自由入力指定
            if (this._vue.$data.SenderInfo.Setting.CharLayoutEx === EditConst.CHAR_LAYOUT_T) {
                // 通常入力が縦書きの場合
                this._vue.$data.SenderInfo.Setting.CharLayout = EditConst.CHAR_LAYOUT_T;
                this._vue.$data.SenderInfo.ShowSenderAlignY = false;
            }
            else {
                // 上記以外の場合(横 or センター横)
                this._vue.$data.SenderInfo.Setting.CharLayout = EditConst.CHAR_LAYOUT_Y;
                this._vue.$data.SenderInfo.ShowSenderAlignY = true;
            }

            this._vue.$data.SenderInfo.Setting.AlignT = EditConst.ALIGN_T_TOP;
            this._vue.$data.SenderInfo.Setting.AlignY = EditConst.ALIGN_Y_LEFT;

            isNormal = false;
        }
        else {
            // 通常入力指定
            if (!this._vue.$data.SenderInfo.Setting.AlignT) {
                this._vue.$data.SenderInfo.Setting.AlignT = EditConst.ALIGN_T_TOP;
            }
            if (!this._vue.$data.SenderInfo.Setting.AlignY) {
                this._vue.$data.SenderInfo.Setting.AlignY = EditConst.ALIGN_Y_LEFT;
            }

            if (this._vue.$data.SenderInfo.Setting.Format === EditConst.SENDER_TYPE_PORSONAL_STR) {
                // 個人
                this._vue.$data.SenderInfo.NormalInput.PersonalUse = true;
            }
            else {
                // 法人
                this._vue.$data.SenderInfo.NormalInput.PersonalUse = false;
            }

            isNormal = true;
        }

        this._vue.$data.SenderInfo.IsNormalInput = isNormal;
    }

    // #endregion

// #endregion

// #region ■内部関数

    /**
     * 差出人編集モードへ画面項目設定(SP用)
     */
    private setSenderEditMode() {

        this._vue.$data.Header.Title = EditConst.TITLE_SENDER_EDIT;

        this._vue.$data.Show.ReturnHomeExBtn = false;
        this._vue.$data.Show.ReturnSenderHomeBtn = true;
        this._vue.$data.Show.CommitNextHomeBtn = false;
        this._vue.$data.Show.SenderDeleteBtn = false;

        this.sonbpIfController.getSenderTextList((list: itemVenderProperty[]) => {
            if (0 < list.length) {
                this._vue.$data.SenderInfo.SetBtnCaption = EditConst.SENDER_APPLY_BTN_UPD;
            }
            else {
                this.InitSenderPallet();
                this._vue.$data.SenderInfo.SetBtnCaption = EditConst.SENDER_APPLY_BTN_ADD;
            }
        });

        this._vue.$data.Show.FooterMenu = true;
        this._vue.$data.Show.EditArea = false;
        this._vue.$data.Show.OparatePallet = false;

        // 外字ボタン表示
        this._vue.$data.Show.SenderGaijiMenu = true;

        this._vue.$data.Show.SenderPanel = true;
    }

    /**
     * 差出人パネルの初期化
     * @param that
     */
    public InitSenderPallet() {

        // デフォルトフォント取得
        const defFont: GetEditInfo.GetEditInfoFontEntity = this._edctrl.getDefaultFont();

        this._vue.$data.SenderInfo.IsNormalInput = true;
        this._vue.$data.SenderInfo.Setting.Font = defFont.name;
        this._vue.$data.SenderInfo.Setting.FontSample = defFont.url;
        this._vue.$data.SenderInfo.Setting.FontSize = EditConst.FONT_SIZE_DEFAULT_Y;

        this._vue.$data.SenderInfo.ShowSenderAlignY = true;
        this._vue.$data.SenderInfo.Setting.CharLayout = EditConst.CHAR_LAYOUT_Y;
        this._vue.$data.SenderInfo.Setting.AlignT = EditConst.ALIGN_T_TOP;
        this._vue.$data.SenderInfo.Setting.AlignY = EditConst.ALIGN_Y_LEFT;

        if (this.ExistsSenderDesgin) {
            // デザインマスタあり
            this._vue.$data.SenderInfo.Setting.CharLayoutEx = editUtil.directionToCharlayout(this.editInfo.master.design.sender.direction);
            this._vue.$data.SenderInfo.Setting.CharLayout = (this._vue.$data.SenderInfo.Setting.CharLayoutEx === EditConst.CHAR_LAYOUT_T) ? EditConst.CHAR_LAYOUT_T : EditConst.CHAR_LAYOUT_Y;

            if (this._vue.$data.SenderInfo.Setting.CharLayout === EditConst.CHAR_LAYOUT_T) {
                this._vue.$data.SenderInfo.ShowSenderAlignY = false;
                this._vue.$data.SenderInfo.Setting.FontSize = EditConst.FONT_SIZE_DEFAULT_T;
            }
        }

        this._vue.$data.SenderInfo.Setting.OutlineFont = false;
        this._vue.$data.SelectCharColor = this.editInfo.master.design.fontColor;
        this._vue.$data.SelectOutlineCharColor = this.editInfo.master.color[0].id;

        this._vue.$data.SenderInfo.NormalInput.PersonalUse = true;
        this._vue.$data.SenderInfo.NormalInput.ZipCode1 = "";
        this._vue.$data.SenderInfo.NormalInput.ZipCode2 = "";
        this._vue.$data.SenderInfo.NormalInput.Address1 = "";
        this._vue.$data.SenderInfo.NormalInput.Address2 = "";
        this._vue.$data.SenderInfo.NormalInput.Address3 = "";
        this._vue.$data.SenderInfo.NormalInput.Company.Name = "";
        this._vue.$data.SenderInfo.NormalInput.Company.Department = "";
        this._vue.$data.SenderInfo.NormalInput.Company.Position = "";
        for (let i: number = 0; i < 6; i++) {
            this._vue.$data.SenderInfo.NormalInput.Names[i].LastNameKana = "";
            this._vue.$data.SenderInfo.NormalInput.Names[i].LastName = "";
            this._vue.$data.SenderInfo.NormalInput.Names[i].FirstNameKana = "";
            this._vue.$data.SenderInfo.NormalInput.Names[i].FirstName = "";
            this._vue.$data.SenderInfo.NormalInput.Names[i].PS = "";
        }
        for (let i: number = 0; i < 2; i++) {
            this._vue.$data.SenderInfo.NormalInput.Contact[i].Type = EditConst.CONTACT_TEL_DISP;
            this._vue.$data.SenderInfo.NormalInput.Contact[i].Tel1 = "";
            this._vue.$data.SenderInfo.NormalInput.Contact[i].Tel2 = "";
            this._vue.$data.SenderInfo.NormalInput.Contact[i].Tel3 = "";
        }
        this._vue.$data.SenderInfo.NormalInput.Email.Mail1 = "";
        this._vue.$data.SenderInfo.NormalInput.Email.Mail2 = "";
        this._vue.$data.SenderInfo.FreeInput = "";


        if (!this._usePcDesign) {
            // SP用
            this._vue.$data.SenderInfo.Setting.Format = EditConst.SENDER_TYPE_PORSONAL_STR;
        }
    }

    /**
     * 差出人デザイン定義の存在チェック
     */
    public get ExistsSenderDesgin(): boolean {

        let exists = false;

        if (this.editInfo.master.design.sender) {
            if (util.verify.isNotLengthZero(this.editInfo.master.design.sender.direction)) {
                exists = true;
            }
        }

        return exists;
    }

    /**
     * 外字ボタンの表示制御
     * */
    private ShowGaijiButton(changeAction=false): void {

        // 外字ボタンの表示制御
        const selFont = this.editInfo.master.font.find(x => x.name == this._vue.$data.SenderInfo.Setting.Font);
        if (!selFont.gaijiFlg) {
            // フォント変更の時だけ、フォントチェックをする。
            if (changeAction) {
                let useGaijiFlg = this._edctrl._gaijiLogic.IsUseGaiji();
                if (useGaijiFlg) {
                    // フォント変更時に外字を利用していたら警告を出す。
                    dialogUtil.createErrorDialog(constDialogMessage.WARN_GAIJI_NOT_SUPPORT_FONT, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Infomation);
                }
            }
            this._vue.$data.Show.GaijiShortCutBtn = false;
            this._edctrl._gaijiLogic.TargetDivId = "";
            this._edctrl._gaijiLogic.DisplayNoneGaijiButton();
        } else {
            this._edctrl._gaijiLogic.DisplayOnGaijiButton();
        }
    }

// #endregion

// #region ■内部関数（validateっぽいけどSender専用みたいなのでこちらに置いておく）

    /**
     * エラーメッセージ成形
     */
    private formatSenderErrMessage(itemName: string, msg: string) {
        return "(" + itemName + ")" + msg;
    }

    /**
     * 郵便番号の有効値判定
     * @param zipcode1          ：郵便番号前半
     * @param zipcode2          ：郵便番号後半
     * @param requiredMsgList   ：エラーメッセージ(必須のみ)
     * @param msgList           ：エラーメッセージ
     */
    private validSenderZipcode(zipcode1: string, zipcode2: string, requiredMsgList: string[], msgList: string[]): boolean {

        // 必須チェック
        if (!zipcode1 && !zipcode2) {
            msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP1, constDialogMessage.WARN_EDIT_EMPTY_CHECK));
            requiredMsgList.push(msgList[msgList.length - 1]);
            msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP2, constDialogMessage.WARN_EDIT_EMPTY_CHECK));
            requiredMsgList.push(msgList[msgList.length - 1]);
            return false;
        }
        else if (zipcode1 && !zipcode2 || !zipcode1 && zipcode2) {
            msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP, constDialogMessage.WARN_EDIT_RELATION_CHECK));
            return false;
        }
        else {
            // 値チェック
            let result: boolean = true;
            if (!util.verify.validNumber(zipcode1)) {
                msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP1, constDialogMessage.WARN_EDIT_HALF_NUMBER_CHECK));
                result = false;
            }

            if (!util.verify.validNumber(zipcode2)) {
                msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP2, constDialogMessage.WARN_EDIT_HALF_NUMBER_CHECK));
                result = false;
            }

            if (EditConst.SENDER_MAXLEN_ZIP1 < zipcode1.length) {
                msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP1, constDialogMessage.WARN_EDIT_FORMAT_CHECK_ZIP1));
                result = false;
            }

            if (EditConst.SENDER_MAXLEN_ZIP2 < zipcode1.length) {
                msgList.push(this.formatSenderErrMessage(EditConst.SENDER_ITEM_NAME_ZIP2, constDialogMessage.WARN_EDIT_FORMAT_CHECK_ZIP2));
                result = false;
            }

            return result;
        }
    }

    /**
     * E-mailの有効値判定
     * @param target    ：E-mail
     */
    private validSenderEmail(target: string): boolean {

        if (target.length === 0) {
            return true;
        }

        if (!util.verify.validHankakuChar(target)) {
            return false;
        }

        if (EditConst.SENDER_MAXLEN_EMAIL < target.length) {
            return false;
        }

        return true;
    }

    /**
     * 電話番号の有効値判定
     * @param tel1              ：電話番号1枠目
     * @param tel2              ：電話番号2枠目
     * @param tel3              ：電話番号3枠目
     * @param telIndex          ：電話番号１ or 電話番号２
     * @param msgList           ：エラーメッセージ
     */
    private validSenderTel(tel1: string, tel2: string, tel3: string, telIndex: number, msgList: string[]): boolean {

        let captionTel: string;
        let captionTel_1: string;
        let captionTel_2: string;
        let captionTel_3: string;

        if (telIndex == 0) {
            captionTel = EditConst.SENDER_ITEM_CAPTION_TEL1;
            captionTel_1 = EditConst.SENDER_ITEM_CAPTION_TEL1_1;
            captionTel_2 = EditConst.SENDER_ITEM_CAPTION_TEL1_2;
            captionTel_3 = EditConst.SENDER_ITEM_CAPTION_TEL1_3;
        }
        else {
            captionTel = EditConst.SENDER_ITEM_CAPTION_TEL2;
            captionTel_1 = EditConst.SENDER_ITEM_CAPTION_TEL2_1;
            captionTel_2 = EditConst.SENDER_ITEM_CAPTION_TEL2_2;
            captionTel_3 = EditConst.SENDER_ITEM_CAPTION_TEL2_3;
        }

        if (tel1.length === 0 && tel2.length === 0 && tel3.length === 0) {
            // すべて未入力
            return true;
        }
        else if (tel1.length === 0 || tel2.length === 0 || tel3.length === 0) {
            // いずれかを入力していたら３つ入力必須
            msgList.push(this.formatSenderErrMessage(captionTel, constDialogMessage.WARN_EDIT_RELATION_CHECK));
            return false;
        }

        // 値チェック
        let result: boolean = true;
        if (!util.verify.validNumber(tel1)) {
            msgList.push(this.formatSenderErrMessage(captionTel_1, constDialogMessage.WARN_EDIT_HALF_NUMBER_CHECK));
            result = false;
        }
        if (!util.verify.validNumber(tel2)) {
            msgList.push(this.formatSenderErrMessage(captionTel_2, constDialogMessage.WARN_EDIT_HALF_NUMBER_CHECK));
            result = false;
        }
        if (!util.verify.validNumber(tel3)) {
            msgList.push(this.formatSenderErrMessage(captionTel_3, constDialogMessage.WARN_EDIT_HALF_NUMBER_CHECK));
            result = false;
        }

        if (EditConst.SENDER_MAXLEN_TEL1 < tel1.length) {
            msgList.push(this.formatSenderErrMessage(captionTel_1, constDialogMessage.WARN_EDIT_FORMAT_CHECK_LEN_TEL1));
            result = false;
        }
        if (EditConst.SENDER_MAXLEN_TEL2 < tel2.length) {
            msgList.push(this.formatSenderErrMessage(captionTel_2, constDialogMessage.WARN_EDIT_FORMAT_CHECK_LEN_TEL2));
            result = false;
        }
        if (EditConst.SENDER_MAXLEN_TEL3 < tel3.length) {
            msgList.push(this.formatSenderErrMessage(captionTel_3, constDialogMessage.WARN_EDIT_FORMAT_CHECK_LEN_TEL3));
            result = false;
        }

        return result;
    }

    /**
     * 名前の有効値判定
     * @param names             ：名前項目
     * @param requiredMsgList   ：エラーメッセージ(必須のみ)
     * @param msgList           ：エラーメッセージ
     */
    private validSenderNames(names: SenderInfoDb.SenderInfoNameDbEntity[], requiredMsgList: string[], msgList: string[]): boolean {

        let result: boolean = true;

        // 必須チェック
        if (names[0].lastName.length === 0) {
            // 姓1は必須
            msgList.push(this.formatSenderErrMessage(
                EditConst.SENDER_ITEM_CAPTION_LNAME + "1",
                constDialogMessage.WARN_EDIT_EMPTY_CHECK));
            requiredMsgList.push(msgList[msgList.length - 1]);
            result = false;
        }
        if (names[0].firstName.length === 0) {
            // 名1は必須
            msgList.push(this.formatSenderErrMessage(
                EditConst.SENDER_ITEM_CAPTION_FNAME + "1",
                constDialogMessage.WARN_EDIT_EMPTY_CHECK));
            requiredMsgList.push(msgList[msgList.length - 1]);
            result = false;
        }

        if (!result) {
            return result;
        }

        // 値チェック
        for (let i: number = 0; i < names.length; i++) {

            // 名：なし、名ルビ：あり
            if ((names[i].firstName || "").length === 0 && 0 < (names[i].firstRubi || "").length) {
                msgList.push(
                    this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_NAME,
                        constDialogMessage.WARN_EDIT_RELATION_CHECK));
                result = false;
            }

            // 姓
            if (!util.verify.validStringLen(names[i].lastName, EditConst.SENDER_MAXLEN_LASTNAME)) {
                msgList.push(
                    this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_LNAME + (i + 1).toString(),
                        constDialogMessage.WARN_EDIT_FORMAT_CHECK_NAME));
                result = false;
            }
            // 名
            if (!util.verify.validStringLen(names[i].firstName, EditConst.SENDER_MAXLEN_FIRSTNAME)) {
                msgList.push(
                    this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_FNAME + (i + 1).toString(),
                        constDialogMessage.WARN_EDIT_FORMAT_CHECK_NAME));
                result = false;
            }

            // 姓ルビ
            if (!util.verify.validStringLen(names[i].lastRubi, EditConst.SENDER_MAXLEN_RUBI)) {
                msgList.push(
                    this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_LRUBI + (i + 1).toString(),
                        constDialogMessage.WARN_EDIT_FORMAT_CHECK_RUBI));
                result = false;
            }

            // 名ルビ
            if (!util.verify.validStringLen(names[i].firstRubi, EditConst.SENDER_MAXLEN_RUBI)) {
                msgList.push(
                    this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_FRUBI + (i + 1).toString(),
                        constDialogMessage.WARN_EDIT_FORMAT_CHECK_RUBI));
                result = false;
            }

            // 添え書き
            if (!util.verify.validStringLen(names[i].ps, EditConst.SENDER_MAXLEN_PS)) {
                msgList.push(
                    this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_PS + (i + 1).toString(),
                        constDialogMessage.WARN_EDIT_FORMAT_CHECK_PS));
                result = false;
            }

            // 肩書
            //if (!this.validStringLen(names[i].title, 64, 32)) {
            //    msgList.push(
            //        this.formatSenderErrMessage(
            //            EditConst.SENDER_ITEM_CAPTION_TITLE + (i + 1).toString(),
            //            constDialogMessage.WARN_EDIT_FORMAT_CHECK_TITLE));
            //    result = false;
            //}

            if (!result) {
                break;
            }
        }

        return result;
    }

    /**
     * パラメータ値を条件にレイアウトコードを取得
     * @param isHojin   ：個人／法人フラグ
     * @param charLayout：文字レイアウトコンボ選択値
     */
    private getLayoutCd(isHojin: boolean, charLayout: string): string {

        let layoutCd: string;

        // レイアウト記号
        if (isHojin) {
            // 法人の場合
            if (charLayout === EditConst.CHAR_LAYOUT_T) {
                // 縦
                layoutCd = EditConst.LAYOUTCD_HOJIN_T;
            }
            else if (charLayout === EditConst.CHAR_LAYOUT_CY) {
                // センター横
                layoutCd = EditConst.LAYOUTCD_HOJIN_CY;
            }
            else {
                // 上記以外(横)
                layoutCd = EditConst.LAYOUTCD_HOJIN_Y;
            }
        }
        else {
            // 個人の場合
            if (charLayout === EditConst.CHAR_LAYOUT_T) {
                // 縦
                layoutCd = EditConst.LAYOUTCD_PERSONAL_T;
            }
            else if (charLayout === EditConst.CHAR_LAYOUT_CY) {
                // センター横
                layoutCd = EditConst.LAYOUTCD_PERSONAL_CY;
            }
            else {
                // 上記以外(横)
                layoutCd = EditConst.LAYOUTCD_PERSONAL_Y;
            }
        }

        return layoutCd;

    }

    /**
     * 生成した差出人アイテムをsonbpへ連携
     * @param selectItem    ：選択アイテム
     * @param setOrder      ：入力オーダー
     * @param reqParam      ：組版実行時の共通パラメータ
     * @param result        ：組版APIのレスポンス
     */
    private setSenderText(selectItem: itemVenderProperty, setOrder: senderTranEntityEx, reqParam: kumihanRequestParam, result: kumihanResponseParam) {

        // 結果判定
        if (result !== null) {
            this._vue.$data.EnableOnChangeForSender = false;

            // 入力内容の保持
            if (selectItem === null) {
                Logger.debug("差出人 新規追加");

                // 新規
                this.sonbpIfController.setSenderText(
                    true,
                    setOrder,
                    reqParam,
                    result.json,
                    () => {
                        Logger.debug("差出人 新規追加 正常終了");
                        // 正常終了の場合
                        this._vue.$data.Show.OparatePalletCover4Top = false;
                        this._vue.$data.SenderInfo.DelBtnEnable = true;
                        this._vue.$data.EnableOnChangeForSender = true;

                        this.sonbpIfController.SenderInfo = setOrder;

                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();

                        if (!this._usePcDesign) {
                            // SP用
                            this.returnSenderHomeBtn(null);
                        }
                    },
                    () => {
                        // 上記以外の場合
                        util.dialogUtil.closeLoading();
                        util.dialogUtil.createErrorDialog(
                            constDialogMessage.ERROR_EDIT_CREATE_SENDER,
                            () => {
                                dialogUtil.closeErrorDialog();
                            });
                        this._vue.$data.EnableOnChangeForSender = true;
                    });
            }
            else {
                Logger.debug("差出人 既存更新");

                // 更新
                this.sonbpIfController.setSenderText(
                    false,
                    setOrder,
                    reqParam,
                    result.json,
                    () => {
                        Logger.debug("差出人 既存更新 正常終了");
                        // 正常終了の場合
                        this.sonbpIfController.SenderInfo = setOrder;
                        this._vue.$data.EnableOnChangeForSender = true;

                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();

                        if (!this._usePcDesign) {
                            // SP用
                            this.returnSenderHomeBtn(null);
                        }
                    },
                    () => {
                        // 上記以外の場合
                        util.dialogUtil.closeLoading();
                        util.dialogUtil.createErrorDialog(
                            constDialogMessage.ERROR_EDIT_CREATE_SENDER,
                            () => {
                                dialogUtil.closeErrorDialog();
                            });
                        this._vue.$data.EnableOnChangeForSender = true;
                    });
            }
        }
        else {
            util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CREATE_SENDER, dialogUtil.closeErrorDialog);
        }

    }

    /**
     * 電話タイプを外字(文字コード)に変換
     * @param telType   ：電話タイプ
     */
    private telType2Gaiji(telType: number): string {

        // フォントにより、記号に割り当てられている文字コードがことなる。
        const selFont = this.editInfo.master.font.find(x => x.name == this._vue.$data.SenderInfo.Setting.Font);

        if (selFont.gaijiFlg) {
            // 店頭機フォント
            if (telType === EditConst.CONTACT_TEL_VAL) {
                return "\uF32D";
            }
            else if (telType === EditConst.CONTACT_CELLULAR_VAL) {
                return "\uF328";
            }
            else if (telType === EditConst.CONTACT_FAX_VAL) {
                return "\uF326";　
            }
            else if (telType === EditConst.CONTACT_TEL_FAX_VAL) {
                return "\uF32A" + "・" + "\uF326";
            }
            else {
                return "";
            }
        } else {
            // 旧ネットフォント
            if (telType === EditConst.CONTACT_TEL_VAL) {
                return "\uE017";
            }
            else if (telType === EditConst.CONTACT_CELLULAR_VAL) {
                return "\uE015";
            }
            else if (telType === EditConst.CONTACT_FAX_VAL) {
                return "\uE00C";
            }
            else if (telType === EditConst.CONTACT_TEL_FAX_VAL) {
                return "\uE044";
            }
            else {
                return "";
            }
        }
    }

    /**
     *  差出人パネルの入力値を収集
     */
    private getSenderOrder(): senderTranEntityEx {

        // 入力値取得

        // 文字サイズ(有効値を格納するため、validSenderOrder()側で格納します)
        //order.size = this._vue.$data.SenderInfo.Setting.FontSize;

        // フォント
        let selFont: GetEditInfo.GetEditInfoFontEntity = util.relic.listFind(this.editInfo.master.font, (f: GetEditInfo.GetEditInfoFontEntity) => {
            return f.name === this._vue.$data.SenderInfo.Setting.Font;
        });

        // 文字色
        let selFontColor: GetEditInfo.GetEditInfoColorEntity = util.relic.listFind(this.editInfo.master.color, (c: GetEditInfo.GetEditInfoColorEntity) => {
            return c.id === this._vue.$data.SelectCharColor;
        });

        let order: senderTranEntityEx = senderTranEntityEx.createDef(this.editInfo.master.design.sender, [selFont], [selFontColor]);
        if (selFont !== undefined) {
            order.fontMaster = selFont;
            order.sender.font = selFont.id;
        }
        order.fontColorMaster = (selFontColor !== undefined) ? selFontColor : null;
        order.sender.color = selFontColor.id;

        // フチ文字
        order.outlineChar = this._vue.$data.SenderInfo.Setting.OutlineFont;
        if (order.outlineChar) {
            // フチ文字色
            let selOutlineFontColor: GetEditInfo.GetEditInfoColorEntity = util.relic.listFind(this.editInfo.master.color, (c: GetEditInfo.GetEditInfoColorEntity) => {
                return c.id === this._vue.$data.SelectOutlineCharColor;
            });
            order.outlineFontColorMaster = (selOutlineFontColor !== undefined) ? selOutlineFontColor : null;
            order.sender.outlineColor = selOutlineFontColor.id;
        }

        // 通常入力(個人 or 法人) or 自由入力
        if (this._vue.$data.SenderInfo.IsNormalInput) {
            if (this._vue.$data.SenderInfo.NormalInput.PersonalUse) {
                order.sender.type = EditConst.SENDER_TYPE_PORSONAL;
            }
            else {
                order.sender.type = EditConst.SENDER_TYPE_CORP;
            }

            // 文字レイアウト
            order.charLayout = this._vue.$data.SenderInfo.Setting.CharLayoutEx;
        }
        else {
            order.sender.type = EditConst.SENDER_TYPE_FREE;

            // 文字レイアウト
            order.charLayout = this._vue.$data.SenderInfo.Setting.CharLayout;
        }

        // 行揃え(組方向)
        if (order.charLayout === EditConst.CHAR_LAYOUT_Y) {
            order.alignDispVal = this._vue.$data.SenderInfo.Setting.AlignY;
            order.sender.direction = EditConst.DIRECTION_Y;
        }
        else if (order.charLayout === EditConst.CHAR_LAYOUT_CY) {
            order.alignDispVal = this._vue.$data.SenderInfo.Setting.AlignCY;
            order.sender.direction = EditConst.DIRECTION_CY;
        }
        else {
            order.alignDispVal = this._vue.$data.SenderInfo.Setting.AlignT;
            order.sender.direction = EditConst.DIRECTION_T;
        }


        // 入力方法別に入力値を取得
        if (order.sender.type === EditConst.SENDER_TYPE_FREE) {
            // 自由入力

            // 文字レイアウト(DB上のALIGN9点)
            if (order.charLayout === EditConst.CHAR_LAYOUT_Y) {
                // 横書き
                if (order.alignDispVal === EditConst.ALIGN_Y_LEFT) {
                    // 横書き左 -> 7
                    order.sender.align = EditConst.ALIGN_7;

                } else if (order.alignDispVal === EditConst.ALIGN_Y_CENTER) {
                    // 横書きセンター -> 8
                    order.sender.align = EditConst.ALIGN_8;

                } else if (order.alignDispVal === EditConst.ALIGN_Y_RIGHT) {
                    // 横書き右 -> 9
                    order.sender.align = EditConst.ALIGN_9;

                }

            } else if (order.charLayout === EditConst.CHAR_LAYOUT_CY) {
                // 横書きセンター -> 6
                order.sender.align = EditConst.ALIGN_6;

            } else {
                // 縦書き
                if (order.alignDispVal === EditConst.ALIGN_T_TOP) {
                    // 縦書き上 -> 9
                    order.sender.align = EditConst.ALIGN_9;

                } else if (order.alignDispVal === EditConst.ALIGN_Y_CENTER) {
                    // 縦書き中 -> 6
                    order.sender.align = EditConst.ALIGN_6;

                } else if (order.alignDispVal === EditConst.ALIGN_Y_RIGHT) {
                    // 縦書き下 -> 3
                    order.sender.align = EditConst.ALIGN_3;

                }
            }
            // 文章
            order.sender.senderInfo.free = this._vue.$data.SenderInfo.FreeInput;
        }
        else {

            order.sender.senderInfo.addresses = [];
            order.sender.senderInfo.corps = [];
            order.sender.senderInfo.emails = [];
            order.sender.senderInfo.names = [];

            // 住所
            let address: SenderInfoDb.SenderInfoAddressDbEntity = new SenderInfoDb.SenderInfoAddressDbEntity();

            // 郵便番号
            address.yubin1 = this._vue.$data.SenderInfo.NormalInput.ZipCode1;
            address.yubin2 = this._vue.$data.SenderInfo.NormalInput.ZipCode2;

            // 住所
            address.jusho1 = this._vue.$data.SenderInfo.NormalInput.Address1;
            address.jusho2 = this._vue.$data.SenderInfo.NormalInput.Address2;
            address.jusho3 = this._vue.$data.SenderInfo.NormalInput.Address3;

            // 電話番号1
            address.telType1 = this.telTypeStrToVal(this._vue.$data.SenderInfo.NormalInput.Contact[0].Type);
            address.telNo1_1 = this._vue.$data.SenderInfo.NormalInput.Contact[0].Tel1;
            address.telNo1_2 = this._vue.$data.SenderInfo.NormalInput.Contact[0].Tel2;
            address.telNo1_3 = this._vue.$data.SenderInfo.NormalInput.Contact[0].Tel3;
            // 電話番号2
            address.telType2 = this.telTypeStrToVal(this._vue.$data.SenderInfo.NormalInput.Contact[1].Type);
            address.telNo2_1 = this._vue.$data.SenderInfo.NormalInput.Contact[1].Tel1;
            address.telNo2_2 = this._vue.$data.SenderInfo.NormalInput.Contact[1].Tel2;
            address.telNo2_3 = this._vue.$data.SenderInfo.NormalInput.Contact[1].Tel3;

            order.sender.senderInfo.addresses.push(address);

            // e-mal 1
            let email1: SenderInfoDb.SenderInfoEmailDbEntity = new SenderInfoDb.SenderInfoEmailDbEntity();
            email1.address = this._vue.$data.SenderInfo.NormalInput.Email.Mail1
            order.sender.senderInfo.emails.push(email1);
            // e-mal 2
            let email2: SenderInfoDb.SenderInfoEmailDbEntity = new SenderInfoDb.SenderInfoEmailDbEntity();
            email2.address = this._vue.$data.SenderInfo.NormalInput.Email.Mail2
            order.sender.senderInfo.emails.push(email2);

            // 名前
            order.sender.senderInfo.names.push(this.getInputSenderName(0));

            if (order.sender.type === EditConst.SENDER_TYPE_CORP) {
                // 法人
                let corp: SenderInfoDb.SenderInfoCorpDbEntity = new SenderInfoDb.SenderInfoCorpDbEntity();

                // 会社名
                corp.name = this._vue.$data.SenderInfo.NormalInput.Company.Name;
                // 部署名
                corp.busyo = this._vue.$data.SenderInfo.NormalInput.Company.Department;
                // 肩書
                order.sender.senderInfo.names[0].title = this._vue.$data.SenderInfo.NormalInput.Company.Position;

                order.sender.senderInfo.corps.push(corp);

                order.sender.senderInfo.isHojin = true;
            }
            else if (order.sender.type === EditConst.SENDER_TYPE_PORSONAL) {
                // 個人
                for (let i: number = 1; i < 6; i++) {
                    order.sender.senderInfo.names.push(this.getInputSenderName(i));
                }

                order.sender.senderInfo.isHojin = false;
            }
        }

        return order;
    }

    /**
     * 電話番号タイプ名をDB値に変更
     * @param telTypeStr    ：電話番号タイプコンボ選択値
     */
    private telTypeStrToVal(telTypeStr: string): number {

        if (telTypeStr === EditConst.CONTACT_TEL_DISP) {
            return EditConst.CONTACT_TEL_VAL;
        }
        else if (telTypeStr === EditConst.CONTACT_CELLULAR_DISP) {
            return EditConst.CONTACT_CELLULAR_VAL;
        }
        else if (telTypeStr === EditConst.CONTACT_FAX_DISP) {
            return EditConst.CONTACT_FAX_VAL;
        }
        else if (telTypeStr === EditConst.CONTACT_TEL_FAX_DISP) {
            return EditConst.CONTACT_TEL_FAX_VAL;
        }

        return EditConst.CONTACT_TEL_VAL
    }

    /**
     * 入力された差出人 名前 を収集
     * @param index
     */
    private getInputSenderName(index: number): SenderInfoDb.SenderInfoNameDbEntity {

        let name: SenderInfoDb.SenderInfoNameDbEntity = new SenderInfoDb.SenderInfoNameDbEntity();

        name.lastName = this._vue.$data.SenderInfo.NormalInput.Names[index].LastName;
        name.lastRubi = this._vue.$data.SenderInfo.NormalInput.Names[index].LastNameKana;
        name.firstName = this._vue.$data.SenderInfo.NormalInput.Names[index].FirstName;
        name.firstRubi = this._vue.$data.SenderInfo.NormalInput.Names[index].FirstNameKana;
        name.ps = this._vue.$data.SenderInfo.NormalInput.Names[index].PS;

        return name;
    }

    /**
     * 差出人の入力値チェック
     * @param order     ：チェック対象
     * @param msgList   ：エラーメッセージ
     */
    private validSenderOrder(order: senderTranEntityEx, msgList: string[]): boolean {

        let result: boolean = true;
        //let useMsgHeader: boolean = false;

        if (order.sender.type == EditConst.SENDER_TYPE_FREE) {
            // 自由入力の場合

            // 文字サイズ
            const fontSize: string = this._vue.$data.SenderInfo.Setting.FontSize;
            if (util.verify.validFontSize(fontSize, msgList)) {
                order.sender.size = Number(fontSize);
            }
            else {
                result = false;
            }

            // 文章
            if (order.sender.senderInfo.free.length === 0) {
                msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_SENDERTEXT);
                result = false;
            }
            else {

                // 最大文字数チェック
                let senderLenCheck = util.verify.validStringLen(order.sender.senderInfo.free, EditConst.SENDER_MAXLEN_FREE);
                if (!senderLenCheck) {
                    msgList.push(constDialogMessage.WARN_EDIT_CHECK_FREESENDERTEXT);
                    result = false;
                }
                // 半角スペース、全角スペースのみの場合は組版させない。
                const texts = order.sender.senderInfo.free.split("\n");
                if (!util.verify.validSpaceAll(texts)) {
                    msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_SENDERTEXT);
                    result = false;
                }
            }
        }
        else {
            // 通常入力の場合

            // フォント
            // →未選択のないコンボなのでスキップ

            // 文字色
            if (order.fontColorMaster === null) {
                msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_CHARCOLOR);
                result = false;
            }

            // 文字レイアウト
            // →未選択のないコンボなのでスキップ

            // 行揃え
            // →未選択のないコンボなのでスキップ

            // フチ文字
            if (order.outlineChar && order.fontColorMaster === null) {
                msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_OUTCHARCOLOR);
                result = false;
            }

            let requiredMsgList: string[] = [];

            // 住所
            for (let i: number = 0; i < order.sender.senderInfo.addresses.length; i++) {

                // 郵便番号
                if (!this.validSenderZipcode(order.sender.senderInfo.addresses[i].yubin1, order.sender.senderInfo.addresses[i].yubin2, requiredMsgList, msgList)) {
                    result = false;
                }

                // 住所
                if (order.sender.senderInfo.addresses[i].jusho1.length === 0) {
                    // 住所1は必須
                    msgList.push(this.formatSenderErrMessage(
                        EditConst.SENDER_ITEM_CAPTION_ADDRESS1,
                        constDialogMessage.WARN_EDIT_EMPTY_CHECK));
                    requiredMsgList.push(msgList[msgList.length - 1]);
                    result = false;
                }
                else {
                    if (!util.verify.validStringLen(order.sender.senderInfo.addresses[i].jusho1, EditConst.SENDER_MAXLEN_JUSHO)) {
                        msgList.push(this.formatSenderErrMessage(
                            EditConst.SENDER_ITEM_CAPTION_ADDRESS1,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_ADDRESS));
                        result = false;
                    }
                    if (!util.verify.validStringLen(order.sender.senderInfo.addresses[i].jusho2, EditConst.SENDER_MAXLEN_JUSHO)) {
                        msgList.push(this.formatSenderErrMessage(
                            EditConst.SENDER_ITEM_CAPTION_ADDRESS2,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_ADDRESS));
                        result = false;
                    }
                    if (!util.verify.validStringLen(order.sender.senderInfo.addresses[i].jusho3, EditConst.SENDER_MAXLEN_JUSHO)) {
                        msgList.push(this.formatSenderErrMessage(
                            EditConst.SENDER_ITEM_CAPTION_ADDRESS3,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_ADDRESS));
                        result = false;
                    }
                }

                // 電話番号
                if (!this.validSenderTel(order.sender.senderInfo.addresses[i].telNo1_1, order.sender.senderInfo.addresses[i].telNo1_2, order.sender.senderInfo.addresses[i].telNo1_3, 0, msgList)) {
                    result = false;
                }
                if (!this.validSenderTel(order.sender.senderInfo.addresses[i].telNo2_1, order.sender.senderInfo.addresses[i].telNo2_2, order.sender.senderInfo.addresses[i].telNo2_3, 1, msgList)) {
                    result = false;
                }

                if (!result) {
                    break;
                }
            }

            // 名前
            if (!this.validSenderNames(order.sender.senderInfo.names, requiredMsgList, msgList)) {
                result = false;
            }

            // E-mail
            for (let i: number = 0; i < order.sender.senderInfo.emails.length; i++) {
                if (!this.validSenderEmail(order.sender.senderInfo.emails[i].address)) {
                    msgList.push(
                        this.formatSenderErrMessage(
                            i === 0 ? EditConst.SENDER_ITEM_CAPTION_EMAIL1 : EditConst.SENDER_ITEM_CAPTION_EMAIL2,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_EMAIL));
                    result = false;
                }
            }

            // 法人？
            if (order.sender.senderInfo.isHojin) {
                // 会社名
                if (!util.verify.validStringLen(order.sender.senderInfo.corps[0].name, EditConst.SENDER_MAXLEN_COMPANY)) {
                    msgList.push(
                        this.formatSenderErrMessage(
                            EditConst.SENDER_ITEM_CAPTION_COMPANY,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_CORPNAME));
                    result = false;
                }

                // 部署名
                if (!util.verify.validStringLen(order.sender.senderInfo.corps[0].busyo, EditConst.SENDER_MAXLEN_DEPARTMENT)) {
                    msgList.push(
                        this.formatSenderErrMessage(
                            EditConst.SENDER_ITEM_CAPTION_DEPARTMENT,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_CORPBUSYO));
                    result = false;
                }

                // 肩書
                if (!util.verify.validStringLen(order.sender.senderInfo.names[0].title, EditConst.SENDER_MAXLEN_TITLE)) {
                    msgList.push(
                        this.formatSenderErrMessage(
                            EditConst.SENDER_ITEM_CAPTION_TITLE,
                            constDialogMessage.WARN_EDIT_FORMAT_CHECK_TITLE));
                    result = false;
                }
            }

        }

        return result;
    }

    /**
     * 郵便番号1が入力されたとき
     */
    public onInputZipCode1(event: JQueryEventObject): void {
        const zipcode1 = this._vue.$data.SenderInfo.NormalInput.ZipCode1;
        if (zipcode1.length == 3) {
            (<HTMLInputElement>this._vue.$refs.zipCode2).focus();
        }
    }

    /**
     * 郵便番号2が入力されたとき
     */
    public onInputZipCode2(event: JQueryEventObject): void {
        const zipcode2 = this._vue.$data.SenderInfo.NormalInput.ZipCode2;
        if (zipcode2.length == 4) {
            (<HTMLInputElement>this._vue.$refs.searchAddrBtn).focus();
        }
    }


    /**
     * 操作パネル→住所検索メソッド
     */
    public async btnClickSearchZipToAddress(event: JQueryEventObject): es6promise.Promise<void> {
        Logger.debug("操作パネル→住所検索押下メソッド");

        const codeZip = [
            this._vue.$data.SenderInfo.NormalInput.ZipCode1,
            this._vue.$data.SenderInfo.NormalInput.ZipCode2
        ];
        const zipno = codeZip.join('');

        // [0-9]以外の文字列が入力されていないかの確認
        if (!RegExp('[0-9]{7}', 'g').test(zipno)) {
            this.showAddrSearchErroDlg("（郵便番号）半角数値7桁で入力してください。");
            return;
        }
                
        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // サーバーへ問い合わせ
        const address = await this.searchZipToAddress(zipno);

        // ローディングダイアログ終了
        util.dialogUtil.closeLoading();

        // 検索が失敗した場合
        if (address == null) {
            this.showAddrSearchErroDlg("郵便番号から住所が見つかりませんでした。");
            return;
        }

        // 結果を格納
        this._vue.$data.SenderInfo.NormalInput.Address1 = address.address1;
        this._vue.$data.SenderInfo.NormalInput.Address2 = address.address2;
        this._vue.$data.SenderInfo.NormalInput.Address3 = address.address3;
    }

    private async searchZipToAddress(zipno: string): es6promise.Promise<SearchZipToAddress> {

        const param = {
            token: this._authToken,
            zipno: zipno,
        }

        return await util.ajax.post(this.WEBAPI_URL_SEARCHADDRESS, JSON.stringify(param)).catch(() => {return null});
    }

// #endregion

}
